var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 351 393",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "matrix(1, 0, 0, 1, 1, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m45.67 207.91.03.22c-24.8 1.07-45 21.6-45 46.81 0 25.87 20.85 46.84 46.56 46.84h3.37c15.54 52.3 65.74 90.46 125.08 90.46 59.33 0 109.53-38.17 125.07-90.46l4.9-.02c25-.82 45.02-21.46 45.02-46.82l-.02-1.54c-.8-24.62-20.47-44.43-44.93-45.27v-66.14h-22.48l-.02 127.48c-1.1 55.36-48.7 100.15-107.54 100.15l-2.1-.01c-58.56-1.07-105.47-46.51-105.47-102.12l.2-61.03v-64.47H45.67v65.93Zm282.57 47.02a24.17 24.17 0 0 1-22.48 24.18v-48.35l2.47.3a24.2 24.2 0 0 1 20 23.87ZM44.42 230.87l1.25-.11v48.35a24.17 24.17 0 0 1-22.48-24.18 24.18 24.18 0 0 1 21.23-24.06Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.77 304.9a10.98 10.98 0 0 1 15.58.21 65.33 65.33 0 0 0 65.04 17.47 65.74 65.74 0 0 0 46.09-49.33A11.02 11.02 0 1 1 258 278c-6.67 30.6-29.44 56.67-61.56 65.88a87.29 87.29 0 0 1-86.9-23.32 11.1 11.1 0 0 1 .23-15.66ZM239.9 65.48l65.84-48.78.01 146.15-253.41 44.69-50-137.35 78.5 23.34L146.47.18l93.44 65.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUud);
export default __webpack_public_path__ + "static/media/uud.e8d316f0a16fb0bac79e7f4d8145b435.svg";
export { ForwardRef as ReactComponent };